import { useMemo, useCallback, useState, useEffect } from 'react'

const breakpoints = [
  'screen and (max-width: 768px)',
  'screen and (min-width: 769px) and (max-width: 1200px)',
  'screen and (min-width: 1201px)',
] as const

type UseMediaReturn = [small: boolean, medium: boolean, large: boolean]

export default function useMedia(): UseMediaReturn {
  const media = useMemo(
    () => breakpoints.map(breakpoint => window.matchMedia(breakpoint)),
    []
  )

  const getMatches = useCallback((): UseMediaReturn => {
    const matches = media.map(mql => mql.matches)
    return [
      !!matches[0], // small
      !!matches[1], // medium
      !!matches[2], // large
    ]
  }, [media])
  const [matches, setMatches] = useState(getMatches)

  useEffect(() => {
    const handler = (_evt: MediaQueryListEvent) => {
      setMatches(getMatches)
    }
    media.forEach(mql => mql.addListener(handler))
    return () => media.forEach(mql => mql.removeListener(handler))
  }, [getMatches, media])

  return matches
}
